export function isValidGroup({ children }: TContent): boolean {
  return children.some((elem) => elem.type === 'core__image' || elem.type === 'core__group');
}
